export default __webpack_public_path__ + "static/media/To look through.3d845c5a.jpg";